import { useEffect, useReducer, useRef, useState } from "react";
import { useIntl } from "react-intl";
import withRoot from "@/withRoot";
import styles from "./header_footer.style";
import { makeStyles } from "tss-react/mui";
import { produce } from "immer";
import { Grid, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import route_map from "@/config/route_map";
import { Iconfont } from "@/lib";
import g_styles from "@/components/public.style";
import { usePageMode } from "@/model/usePageMode";
import CONST from "@/config/const";
import GetIntl from "@/components/getIntl";
// import logo_light from "@/assets/logo_light.png";
import logo_night from "@/assets/logo_dark.png";
import telegram from "@/assets/svg/telegram.svg";
import x from "@/assets/svg/x.svg";
import instagram from "@/assets/svg/instagram.svg";
import linktree from "@/assets/svg/linktree.svg";
import medium from "@/assets/svg/medium.svg";
import tiktok from "@/assets/svg/tiktok.svg";
import youtube from "@/assets/svg/youtube.svg";
import userinfo from "@/services/userinfo";
import { useRequest } from "ahooks";
import helper from "@/utils/helper";

const ChevronDownIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 7.5L10 12.5L15 7.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const useStyles = makeStyles()((theme) => ({
  ...g_styles(theme),
  ...styles(theme),
}));

const initState = {
  open_lang: false,
  zendeskopen: false,
};
const reducer = produce((draft, action = { paylod: {}, type: "@@INTT" }) => {
  const { type, payload } = action;
  switch (type) {
    default:
      Object.keys(payload).map((item) => {
        draft[item] = payload[item];
      });
  }
}, initState);

const cms = {
  zh_CN: "zh-cn",
  en_US: "en-us",
  zh_TW: "zh-tw",
};

const langObj = {
  en_US: "en-us",
  zh_CN: "en-us",
  zh_TW: "zh-tw",
  ja_JP: "ja",
  ru_RU: "ru",
  vi_VN: "vi",
};

function FooterRC(props) {
  const intl = useIntl();
  const { classes, cx } = useStyles();
  const [state, dispatch] = useReducer(reducer, initState);
  const ref_dom = useRef();
  const { lang, decimal, bodySize, appdownload, mode } = usePageMode();
  const isMobile = bodySize.width < 1024;
  const [openSections, setOpenSections] = useState({});
  const toggleSection = (key) => {
    setOpenSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };
  const [languageFooterList, setLanguageFooterList] = useState({
    footerAboutLink: [
      {
        content: "",
      },
    ],
    footerLegalUserAgreement: [
      {
        content: "",
      },
    ],
    footerLegalPrivacyPolicy: [
      {
        content: "",
      },
    ],
    footerLegalAmlPolicy: [
      {
        content: "",
      },
    ],
    footerListingApplication: [
      {
        content: "",
      },
    ],
    footerInfoFeeSchedule: [
      {
        content: "",
      },
    ],
    footerInfoAnnouncements: [
      {
        content: "",
      },
    ],
    footerSupportHelpCenter: [
      {
        content: "",
      },
    ],
    footerSupportSubmitTicket: [
      {
        content: "",
      },
    ],
  });
  const openZD = () => {
    window.zE("messenger", "show");
    window.zE("messenger", "open");
  };
  const goto = (type) => () => {
    // 帮助中心
    if (type == 1) {
      window.open(
        languageFooterList?.footerSupportHelpCenter[0]?.content,
        "_blank",
      );
    }
    // 提交工单
    if (type == 2) {
      window.open(
        languageFooterList?.footerSupportSubmitTicket[0]?.content,
        "_blank",
      );
    }
    // zendesk
    if (type == 3) {
      if (state.zendeskopen) {
        window.zE && window.zE("messenger", "close");
        dispatch({
          payload: {
            zendeskopen: false,
          },
        });
        return;
      }
      dispatch({
        payload: {
          zendeskopen: true,
        },
      });
      window.zE && window.zE("messenger", "open");
    }
  };
  const { loading: languageFooterLoading, runAsync: runAsyncLanguageFooter } =
    useRequest(userinfo.getLanguageFooterList, {
      manual: true,
    });
  const getLanguageFooterListFn = async () => {
    const cachedData = helper.getCachedMD5("languageFooterList");
    const res = await runAsyncLanguageFooter({
      payload: {
        md5: cachedData?.md5 || "",
      },
    });
    if (res.code == 0) {
      if (res.data.footerLanguage) {
        const obj = {
          ...languageFooterList,
          ...res.data.footerLanguage[lang],
          affiliate_invite_link: res.data.affiliate_invite_link,
          spot_zero_fee_date: res.data.spot_zero_fee_date,
        };
        setLanguageFooterList(obj);
        helper.setCachedMD5("languageFooterList", {
          md5: res.data.md5,
          data: obj,
        });
      } else {
        setLanguageFooterList(cachedData?.data);
      }
    }
  };
  useEffect(() => {
    getLanguageFooterListFn();
  }, []);
  return (
    <footer className={cx(classes.footer)}>
      <div className={classes.footer_con}>
        <div className="item item1">
          {/* {mode == "light" ? (
            <img src={logo_light} height="24" />
          ) : (
            <img src={logo_night} height="24" />
          )} */}
          <img src={logo_night} height="24" />
          <div>
            <p>{intl.formatMessage({ id: "footer.contractus" })}</p>
            <a
              href={`mailto:${lang === "ja_JP" ? "support_jp@x.me" : "support@x.me"}`}
            >
              {lang === "ja_JP" ? "support_jp@x.me" : "support@x.me"}
            </a>
            <a href="mailto:business@x.me">business@x.me</a>
            {/* support@x.me */}
          </div>
          <div>
            <p>{intl.formatMessage({ id: "footer.media" })}</p>
            <Grid container className={classes.medias}>
              <Grid item>
                <a href={CONST.tg[lang] || CONST.tg["en_US"]} target="_blank">
                  <svg data-src={telegram} width={24} height={24}></svg>
                </a>
              </Grid>
              <Grid item>
                <a href={CONST.x[lang] || CONST.x["en_US"]} target="_blank">
                  <svg data-src={x} width={24} height={24}></svg>
                </a>
              </Grid>
              <Grid item>
                <a href={CONST.tiktok} target="_blank">
                  <svg data-src={tiktok} width={24} height={24}></svg>
                </a>
              </Grid>
              <Grid item>
                <a href={CONST.medium} target="_blank">
                  <svg data-src={medium} width={24} height={24}></svg>
                </a>
              </Grid>
              <Grid item>
                <a href={CONST.youtube} target="_blank">
                  <svg data-src={youtube} width={24} height={24}></svg>
                </a>
              </Grid>
              {/* <Grid item>
                <a href={CONST.instagram} target="_blank">
                  <svg data-src={instagram} width={24} height={24}></svg>
                </a>
              </Grid>
              <Grid item>
                <a href={CONST.linktree} target="_blank">
                  <svg data-src={linktree} width={24} height={24}></svg>
                </a>
              </Grid> */}
            </Grid>
          </div>
        </div>
        <div className="item item2">
          <h2>{intl.formatMessage({ id: "footer.about" })}</h2>
          <a
            href={languageFooterList?.footerAboutLink[0]?.content}
            target="_blank"
          >
            {intl.formatMessage({ id: "footer.about" })}
          </a>
          {/* {lang == "en_US" ? (
            <a href={"https://blog.x.me"} target="_blank">
              XME Blog
            </a>
          ) : (
            ""
          )} */}
          <a
            href={languageFooterList?.footerLegalUserAgreement[0]?.content}
            target="_blank"
          >
            {intl.formatMessage({ id: "footer.agreement" })}
          </a>
          <a
            href={languageFooterList?.footerLegalPrivacyPolicy[0]?.content}
            target="_blank"
          >
            {intl.formatMessage({ id: "footer.privacy" })}
          </a>
          <a
            href={languageFooterList?.footerLegalAmlPolicy[0]?.content}
            target="_blank"
          >
            {intl.formatMessage({ id: "footer.disclaimer" })}
          </a>
        </div>
        <div className="item item2">
          <h2>{intl.formatMessage({ id: "footer.product" })}</h2>
          {/* <a href={route_map.otc}>
            {intl.formatMessage({ id: "footer.creditCardPurchase" })}
          </a> */}
          <a href={route_map.trade}>
            {intl.formatMessage({ id: "footer.trade" })}
          </a>
          <a href={route_map.futures}>
            {intl.formatMessage({ id: "footer.futures" })}
          </a>
          <a href={route_map.kol}>
            {intl.formatMessage({ id: "footer.copyTrading" })}
          </a>
          {/* <a href={route_map.kol}>
            {intl.formatMessage({ id: "footer.koltrade" })}
          </a> */}
          <a href={route_map.bonus}>
            {intl.formatMessage({ id: "footer.bonus" })}
          </a>
        </div>
        <div className="item item2">
          <h2>{intl.formatMessage({ id: "footer.business" })}</h2>
          <a
            href={languageFooterList?.footerListingApplication[0]?.content}
            target="_blank"
          >
            {intl.formatMessage({ id: "footer.cms.apply" })}
          </a>
          <a
            href={
              languageFooterList?.affiliate_invite_link?.[
                lang == "zh_TW" ? "zh_TW" : "en_US"
              ]
            }
            target="_blank"
          >
            {intl.formatMessage({ id: "footer.agent.apply" })}
          </a>
          <a
            href={languageFooterList?.footerInfoFeeSchedule[0]?.content}
            target="_blank"
          >
            {intl.formatMessage({ id: "footer.fee" })}
          </a>
          {/* <a href={route_map.c2cApply}>{intl.formatMessage({ id: "footer.c2c.apply" })}</a> */}
        </div>
        <div className="item item2">
          <h2>{intl.formatMessage({ id: "footer.support" })}</h2>
          {/* <a onClick={openZD}>
            {intl.formatMessage({ id: "footer.customerService" })}
          </a> */}
          <a
            href={languageFooterList?.footerInfoAnnouncements[0]?.content}
            target="_blank"
          >
            {intl.formatMessage({ id: "footer.mesage" })}
          </a>
          <a
            href={languageFooterList?.footerSupportHelpCenter[0]?.content}
            target="_blank"
          >
            {intl.formatMessage({ id: "footer.help" })}
          </a>
          <a
            href={languageFooterList?.footerSupportSubmitTicket[0]?.content}
            target="_blank"
          >
            {intl.formatMessage({ id: "footer.requests" })}
          </a>
          <a href={route_map.official}>
            {intl.formatMessage({ id: "footer.officialVerify" })}
          </a>
        </div>
      </div>
      <div className={classes.footer_mobile}>
        <div className={classes.footer_mobile_group}>
          <div
            className={cx(classes.footer_mobile_header, {
              expanded: openSections["about"],
            })}
            onClick={() => toggleSection("about")}
          >
            <h3>{intl.formatMessage({ id: "footer.about" })}</h3>
            <ChevronDownIcon />
          </div>
          <div
            className={cx(classes.footer_mobile_links, {
              expanded: openSections["about"],
            })}
          >
            <a
              href={languageFooterList?.footerAboutLink[0]?.content}
              target="_blank"
            >
              {intl.formatMessage({ id: "footer.about" })}
            </a>
            {/* {lang == "en_US" && (
              <a href={"https://blog.x.me"} target="_blank">
                VOOX Blog
              </a>
            )} */}
            <a
              href={languageFooterList?.footerLegalUserAgreement[0]?.content}
              target="_blank"
            >
              {intl.formatMessage({ id: "footer.agreement" })}
            </a>
            <a
              href={languageFooterList?.footerLegalPrivacyPolicy[0]?.content}
              target="_blank"
            >
              {intl.formatMessage({ id: "footer.privacy" })}
            </a>
            <a
              href={languageFooterList?.footerLegalAmlPolicy[0]?.content}
              target="_blank"
            >
              {intl.formatMessage({ id: "footer.disclaimer" })}
            </a>
          </div>
        </div>
        <div className={classes.footer_mobile_group}>
          <div
            className={cx(classes.footer_mobile_header, {
              expanded: openSections["products"],
            })}
            onClick={() => toggleSection("products")}
          >
            <h3>{intl.formatMessage({ id: "footer.product" })}</h3>
            <ChevronDownIcon />
          </div>
          <div
            className={cx(classes.footer_mobile_links, {
              expanded: openSections["products"],
            })}
          >
            <a href={route_map.trade}>
              {intl.formatMessage({ id: "footer.trade" })}
            </a>
            <a href={route_map.futures}>
              {intl.formatMessage({ id: "footer.futures" })}
            </a>
            <a href={route_map.kol}>
              {intl.formatMessage({ id: "footer.copyTrading" })}
            </a>
            <a href={route_map.bonus}>
              {intl.formatMessage({ id: "footer.bonus" })}
            </a>
          </div>
        </div>
        <div className={classes.footer_mobile_group}>
          <div
            className={cx(classes.footer_mobile_header, {
              expanded: openSections["business"],
            })}
            onClick={() => toggleSection("business")}
          >
            <h3>{intl.formatMessage({ id: "footer.business" })}</h3>
            <ChevronDownIcon />
          </div>
          <div
            className={cx(classes.footer_mobile_links, {
              expanded: openSections["business"],
            })}
          >
            <a
              href={languageFooterList?.footerListingApplication[0]?.content}
              target="_blank"
            >
              {intl.formatMessage({ id: "footer.cms.apply" })}
            </a>
            <a
              href={
                languageFooterList?.affiliate_invite_link?.[
                  lang == "zh_TW" ? "zh_TW" : "en_US"
                ]
              }
              target="_blank"
            >
              {intl.formatMessage({ id: "footer.agent.apply" })}
            </a>
            <a
              href={languageFooterList?.footerInfoFeeSchedule[0]?.content}
              target="_blank"
            >
              {intl.formatMessage({ id: "footer.fee" })}
            </a>
          </div>
        </div>
        <div className={classes.footer_mobile_group}>
          <div
            className={cx(classes.footer_mobile_header, {
              expanded: openSections["support"],
            })}
            onClick={() => toggleSection("support")}
          >
            <h3>{intl.formatMessage({ id: "footer.support" })}</h3>
            <ChevronDownIcon />
          </div>
          <div
            className={cx(classes.footer_mobile_links, {
              expanded: openSections["support"],
            })}
          >
            <a
              href={languageFooterList?.footerInfoAnnouncements[0]?.content}
              target="_blank"
            >
              {intl.formatMessage({ id: "footer.mesage" })}
            </a>
            <a
              href={languageFooterList?.footerSupportHelpCenter[0]?.content}
              target="_blank"
            >
              {intl.formatMessage({ id: "footer.help" })}
            </a>
            <a
              href={languageFooterList?.footerSupportSubmitTicket[0]?.content}
              target="_blank"
            >
              {intl.formatMessage({ id: "footer.requests" })}
            </a>
            <a href={route_map.official}>
              {intl.formatMessage({ id: "footer.officialVerify" })}
            </a>
          </div>
        </div>
      </div>
      <div className={classes.footer_mobile_bottom}>
        <div className="contact">
          <p>{intl.formatMessage({ id: "footer.contractus" })}</p>
          <a
            href={`mailto:${lang === "ja_JP" ? "support_jp@x.me" : "support@x.me"}`}
          >
            {lang === "ja_JP" ? "support_jp@x.me" : "support@x.me"}
          </a>
          <a href="mailto:business@x.me">business@x.me</a>
          {/* support@x.me */}
        </div>
        <div className="social">
          <p>{intl.formatMessage({ id: "footer.media" })}</p>
          <div className="icons">
            <a href={CONST.tg[lang] || CONST.tg["en_US"]} target="_blank">
              <svg data-src={telegram} width={24} height={24}></svg>
            </a>
            <a href={CONST.x[lang] || CONST.x["en_US"]} target="_blank">
              <svg data-src={x} width={24} height={24}></svg>
            </a>
            <a href={CONST.tiktok} target="_blank">
              <svg data-src={tiktok} width={24} height={24}></svg>
            </a>
            <a href={CONST.medium} target="_blank">
              <svg data-src={medium} width={24} height={24}></svg>
            </a>
            <a href={CONST.youtube} target="_blank">
              <svg data-src={youtube} width={24} height={24}></svg>
            </a>
            {/* <a href={CONST.instagram} target="_blank">
              <svg data-src={instagram} width={24} height={24}></svg>
            </a>
            <a href={CONST.linktree} target="_blank">
              <svg data-src={linktree} width={24} height={24}></svg>
            </a> */}
          </div>
        </div>
      </div>
      <div className={classes.footer_con2}>
        <span>{intl.formatMessage({ id: "footer.companyname" })}</span>
        <span>{intl.formatMessage({ id: "footer.companynumber" })}</span>
        <span>{intl.formatMessage({ id: "footer.companyaddress" })}</span>
      </div>
      <div className={classes.custommenu}>
        <div className="con">
          <div className="item" onClick={goto(3)}>
            <Tooltip
              title={intl.formatMessage({ id: "footer.online_custom" })}
              arrow
              placement="top"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M36.446 30.7642V21.3324C36.446 14.4582 30.8733 8.88556 23.9991 8.88556V8.88556C17.1249 8.88556 11.5522 14.4582 11.5522 21.3324L11.5522 30.7642"
                  stroke="currentColor"
                  strokeWidth="3.2"
                />
                <path
                  d="M24.9234 38.7382L27.5534 38.7382C32.4648 38.7382 36.4463 34.7568 36.4463 29.8454V29.8454"
                  stroke="currentColor"
                  strokeWidth="3.2"
                />
                <rect
                  x="10.1333"
                  y="23.0688"
                  width="7.98679"
                  height="7.69531"
                  fill="currentColor"
                />
                <rect
                  x="28.9321"
                  y="23.0688"
                  width="8.9243"
                  height="7.69531"
                  fill="currentColor"
                />
              </svg>
            </Tooltip>
          </div>
          <div className="item" onClick={goto(2)}>
            <Tooltip
              title={intl.formatMessage({ id: "footer.requests" })}
              arrow
              placement="top"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_1359_13486)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.3389 7.97925H29.0251L37.6617 16.7055V40.0205H10.3389V7.97925Z"
                    stroke="currentColor"
                    strokeWidth="3.2"
                    strokeLinejoin="bevel"
                  />
                  <path
                    d="M20.0382 22.0358C19.7828 21.5252 19.6392 20.949 19.6392 20.3393C19.6392 18.2417 21.3396 16.5413 23.4372 16.5413C25.5348 16.5413 27.2353 18.2417 27.2353 20.3393C27.2353 21.7725 26.4414 23.0203 25.2695 23.667C24.345 24.1771 23.4372 24.9937 23.4372 26.0495C23.4372 27.6249 23.4372 28.3225 23.4372 28.3225"
                    stroke="currentColor"
                    strokeWidth="3.2"
                  />
                  <rect
                    x="22.6216"
                    y="30.7534"
                    width="1.63182"
                    height="1.63182"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="1.63182"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1359_13486">
                    <rect width="48" height="48" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </Tooltip>
          </div>
          <div className="item" onClick={goto(1)}>
            <Tooltip
              title={intl.formatMessage({ id: "footer.help" })}
              arrow
              placement="top"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <circle
                    cx="24"
                    cy="24"
                    r="15.506"
                    stroke="currentColor"
                    strokeWidth="3.2"
                  />
                  <path
                    d="M20.6007 22.0358C20.3453 21.5252 20.2017 20.949 20.2017 20.3393C20.2017 18.2416 21.9021 16.5412 23.9997 16.5412C26.0973 16.5412 27.7978 18.2416 27.7978 20.3393C27.7978 21.7725 27.0039 23.0202 25.832 23.6669C24.9075 24.177 23.9997 24.9936 23.9997 26.0495C23.9997 27.6248 23.9997 28.3225 23.9997 28.3225"
                    stroke="currentColor"
                    strokeWidth="3.2"
                  />
                  <rect
                    x="22.3679"
                    y="29.9375"
                    width="3.26364"
                    height="3.26364"
                    fill="currentColor"
                  />
                </g>
              </svg>
            </Tooltip>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterRC;
